var parseVersion = (str) => {
	// see webpack/lib/util/semver.js for original code
	var p=p=>{return p.split(".").map(p=>{return+p==p?+p:p})},n=/^([^-+]+)?(?:-([^+]+))?(?:\+(.+))?$/.exec(str),r=n[1]?p(n[1]):[];return n[2]&&(r.length++,r.push.apply(r,p(n[2]))),n[3]&&(r.push([]),r.push.apply(r,p(n[3]))),r;
}
var versionLt = (a, b) => {
	// see webpack/lib/util/semver.js for original code
	a=parseVersion(a),b=parseVersion(b);for(var r=0;;){if(r>=a.length)return r<b.length&&"u"!=(typeof b[r])[0];var e=a[r],n=(typeof e)[0];if(r>=b.length)return"u"==n;var t=b[r],f=(typeof t)[0];if(n!=f)return"o"==n&&"n"==f||("s"==f||"u"==n);if("o"!=n&&"u"!=n&&e!=t)return e<t;r++}
}
var rangeToString = (range) => {
	// see webpack/lib/util/semver.js for original code
	var r=range[0],n="";if(1===range.length)return"*";if(r+.5){n+=0==r?">=":-1==r?"<":1==r?"^":2==r?"~":r>0?"=":"!=";for(var e=1,a=1;a<range.length;a++){e--,n+="u"==(typeof(t=range[a]))[0]?"-":(e>0?".":"")+(e=2,t)}return n}var g=[];for(a=1;a<range.length;a++){var t=range[a];g.push(0===t?"not("+o()+")":1===t?"("+o()+" || "+o()+")":2===t?g.pop()+" "+g.pop():rangeToString(t))}return o();function o(){return g.pop().replace(/^\((.+)\)$/,"$1")}
}
var satisfy = (range, version) => {
	// see webpack/lib/util/semver.js for original code
	if(0 in range){version=parseVersion(version);var e=range[0],r=e<0;r&&(e=-e-1);for(var n=0,i=1,a=!0;;i++,n++){var f,s,g=i<range.length?(typeof range[i])[0]:"";if(n>=version.length||"o"==(s=(typeof(f=version[n]))[0]))return!a||("u"==g?i>e&&!r:""==g!=r);if("u"==s){if(!a||"u"!=g)return!1}else if(a)if(g==s)if(i<=e){if(f!=range[i])return!1}else{if(r?f>range[i]:f<range[i])return!1;f!=range[i]&&(a=!1)}else if("s"!=g&&"n"!=g){if(r||i<=e)return!1;a=!1,i--}else{if(i<=e||s<g!=r)return!1;a=!1}else"s"!=g&&"n"!=g&&(a=!1,i--)}}var t=[],o=t.pop.bind(t);for(n=1;n<range.length;n++){var u=range[n];t.push(1==u?o()|o():2==u?o()&o():u?satisfy(u,version):!o())}return!!o();
}
const exists = (scope, key) => {
	return scope && __webpack_require__.o(scope, key);
}
const get = (entry) => {
	entry.loaded = 1;
	return entry.get()
};
const eagerOnly = (versions) => {
	return Object.keys(versions).reduce((filtered, version) => {
			if (versions[version].eager) {
				filtered[version] = versions[version];
			}
			return filtered;
	}, {});
};
const findLatestVersion = (scope, key, eager) => {
	const versions = eager ? eagerOnly(scope[key]) : scope[key];
	var key = Object.keys(versions).reduce((a, b) => {
		return !a || versionLt(a, b) ? b : a;
	}, 0);
	return key && versions[key];
};
const findSatisfyingVersion = (scope, key, requiredVersion, eager) => {
	const versions = eager ? eagerOnly(scope[key]) : scope[key];
	var key = Object.keys(versions).reduce((a, b) => {
		if (!satisfy(requiredVersion, b)) return a;
		return !a || versionLt(a, b) ? b : a;
	}, 0);
	return key && versions[key]
};
const findSingletonVersionKey = (scope, key, eager) => {
	const versions = eager ? eagerOnly(scope[key]) : scope[key];
	return Object.keys(versions).reduce((a, b) => {
		return !a || (!versions[a].loaded && versionLt(a, b)) ? b : a;
	}, 0);
};
const getInvalidSingletonVersionMessage = (scope, key, version, requiredVersion) => {
	return "Unsatisfied version " + version + " from " + (version && scope[key][version].from) + " of shared singleton module " + key + " (required " + rangeToString(requiredVersion) + ")"
};
const getInvalidVersionMessage = (scope, scopeName, key, requiredVersion, eager) => {
	const versions = scope[key];
	return "No satisfying version (" + rangeToString(requiredVersion) + ")" + (eager ? " for eager consumption" : "") + " of shared module " + key + " found in shared scope " + scopeName + ".\n" +
		"Available versions: " + Object.keys(versions).map((key) => {
		return key + " from " + versions[key].from;
	}).join(", ");
};
const fail = (msg) => {
	throw new Error(msg);
}
const failAsNotExist = (scopeName, key) => {
	return fail("Shared module " + key + " doesn't exist in shared scope " + scopeName);
}
const warn = /*#__PURE__*/ (msg) => {
	if (typeof console !== "undefined" && console.warn) console.warn(msg);
};
const init = (fn) => (function(scopeName, key, eager, c, d) {
	const promise = __webpack_require__.I(scopeName);
	if (promise?.then && !eager) {
		return promise.then(fn.bind(fn, scopeName, __webpack_require__.S[scopeName], key, false, c, d));
	}
	return fn(scopeName, __webpack_require__.S[scopeName], key, eager, c, d);
});

const useFallback = (scopeName, key, fallback) => {
	return fallback ? fallback() : failAsNotExist(scopeName, key);
}
const load = /*#__PURE__*/ init((scopeName, scope, key, eager, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	return get(findLatestVersion(scope, key, eager));
});
const loadVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	const satisfyingVersion = findSatisfyingVersion(scope, key, requiredVersion, eager);
	if (satisfyingVersion) return get(satisfyingVersion);
	warn(getInvalidVersionMessage(scope, scopeName, key, requiredVersion, eager))
	return get(findLatestVersion(scope, key, eager));
});
const loadStrictVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	const satisfyingVersion = findSatisfyingVersion(scope, key, requiredVersion, eager);
	if (satisfyingVersion) return get(satisfyingVersion);
	if (fallback) return fallback();
	fail(getInvalidVersionMessage(scope, scopeName, key, requiredVersion, eager));
});
const loadSingleton = /*#__PURE__*/ init((scopeName, scope, key, eager, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	const version = findSingletonVersionKey(scope, key, eager);
	return get(scope[key][version]);
});
const loadSingletonVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	const version = findSingletonVersionKey(scope, key, eager);
	if (!satisfy(requiredVersion, version)) {
		warn(getInvalidSingletonVersionMessage(scope, key, version, requiredVersion));
	}
	return get(scope[key][version]);
});
const loadStrictSingletonVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	const version = findSingletonVersionKey(scope, key, eager);
	if (!satisfy(requiredVersion, version)) {
		fail(getInvalidSingletonVersionMessage(scope, key, version, requiredVersion));
	}
	return get(scope[key][version]);
});
const installedModules = {};
const moduleToHandlerMapping = {
	50318: () => (loadSingletonVersion("default", "react", false, [1,18,3,1], () => (__webpack_require__.e("node_modules_react_index_js").then(() => (() => (__webpack_require__(96540))))))),
	9734: () => (loadSingletonVersion("default", "axios", false, [1,1,15,2], () => (__webpack_require__.e("vendors-node_modules_axios_index_js").then(() => (() => (__webpack_require__(76717))))))),
	59166: () => (loadSingleton("default", "customer_portal-ui-shared", false, () => (Promise.all([__webpack_require__.e("vendors-node_modules_react-router_esm_react-router_js"), __webpack_require__.e("vendors-node_modules_chart_js_dist_chunks_helpers_dataset_js"), __webpack_require__.e("vendors-node_modules_babel_runtime_helpers_esm_extends_js-node_modules_babel_runtime_helpers_-e7da8f"), __webpack_require__.e("webpack_sharing_consume_default_react_react-_15a2"), __webpack_require__.e("webpack_sharing_consume_default_mdbreact_mdbreact-webpack_sharing_consume_default_react-dom_r-327f02"), __webpack_require__.e("webpack_sharing_consume_default_chart_js_chart_js-webpack_sharing_consume_default_chart_js_ch-8d835d")]).then(() => (() => (__webpack_require__(9504))))))),
	41727: () => (loadSingletonVersion("default", "react-dom", false, [0,16,6,0], () => (Promise.all([__webpack_require__.e("vendors-node_modules_react-dom_index_js"), __webpack_require__.e("webpack_sharing_consume_default_react_react-_c673")]).then(() => (() => (__webpack_require__(40961))))))),
	47359: () => (loadSingletonVersion("default", "react", false, [0,16,6,0], () => (__webpack_require__.e("node_modules_react_index_js").then(() => (() => (__webpack_require__(96540))))))),
	55931: () => (loadSingleton("default", "react", false, () => (__webpack_require__.e("node_modules_react_index_js").then(() => (() => (__webpack_require__(96540))))))),
	31245: () => (loadSingletonVersion("default", "react", false, [0,16,8,0], () => (__webpack_require__.e("node_modules_react_index_js").then(() => (() => (__webpack_require__(96540))))))),
	51532: () => (loadSingletonVersion("default", "react", false, [0,16,14,0], () => (__webpack_require__.e("node_modules_react_index_js").then(() => (() => (__webpack_require__(96540))))))),
	41935: () => (loadSingletonVersion("default", "react", false, [0,16,8,6], () => (__webpack_require__.e("node_modules_react_index_js").then(() => (() => (__webpack_require__(96540))))))),
	70058: () => (loadSingletonVersion("default", "react-dom", false, [0,16,14,0], () => (Promise.all([__webpack_require__.e("vendors-node_modules_react-dom_index_js"), __webpack_require__.e("webpack_sharing_consume_default_react_react-_c673")]).then(() => (() => (__webpack_require__(40961))))))),
	93917: () => (loadSingletonVersion("default", "react-redux", false, [1,9,1,0], () => (Promise.all([__webpack_require__.e("vendors-node_modules_react-redux_dist_react-redux_mjs"), __webpack_require__.e("webpack_sharing_consume_default_react_react-webpack_sharing_consume_default_react_react")]).then(() => (() => (__webpack_require__(45135))))))),
	17040: () => (load("default", "./src/context/VesselContext", false, () => (Promise.all([__webpack_require__.e("vendors-node_modules_azure_msal-browser_dist_app_PublicClientApplication_mjs"), __webpack_require__.e("webpack_sharing_consume_default_react_react-_c673"), __webpack_require__.e("webpack_sharing_consume_default_axios_axios"), __webpack_require__.e("src_context_VesselContext_tsx")]).then(() => (() => (__webpack_require__(52467))))))),
	31821: () => (loadSingletonVersion("default", "react-router-dom", false, [1,7,0,1], () => (Promise.all([__webpack_require__.e("vendors-node_modules_react-router-dom_dist_index_mjs"), __webpack_require__.e("webpack_sharing_consume_default_react-dom_react-dom-webpack_sharing_consume_default_react_rea-afa71f"), __webpack_require__.e("node_modules_process_browser_js-_f28c0")]).then(() => (() => (__webpack_require__(3234))))))),
	93015: () => (loadSingletonVersion("default", "react", false, [,[1,18],[1,17],[1,16,8,0],1,1], () => (__webpack_require__.e("node_modules_react_index_js").then(() => (() => (__webpack_require__(96540))))))),
	41347: () => (loadSingletonVersion("default", "redux", false, [1,5,0,1], () => (__webpack_require__.e("node_modules_redux_dist_redux_mjs").then(() => (() => (__webpack_require__(93079))))))),
	94442: () => (load("default", "./src/context/VesselSubscriptionContext", false, () => (Promise.all([__webpack_require__.e("vendors-node_modules_azure_msal-browser_dist_app_PublicClientApplication_mjs"), __webpack_require__.e("webpack_sharing_consume_default_react_react-_c673"), __webpack_require__.e("webpack_sharing_consume_default_axios_axios"), __webpack_require__.e("src_context_VesselSubscriptionContext_tsx")]).then(() => (() => (__webpack_require__(6086))))))),
	33073: () => (loadSingleton("default", "react-dom", false, () => (__webpack_require__.e("vendors-node_modules_react-dom_index_js").then(() => (() => (__webpack_require__(40961))))))),
	30668: () => (loadSingletonVersion("default", "react", false, [0,15], () => (__webpack_require__.e("node_modules_react_index_js").then(() => (() => (__webpack_require__(96540))))))),
	23285: () => (loadSingletonVersion("default", "react-dom", false, [4,17,0,1], () => (Promise.all([__webpack_require__.e("vendors-node_modules_react-dom_index_js"), __webpack_require__.e("webpack_sharing_consume_default_react_react-_c673")]).then(() => (() => (__webpack_require__(40961))))))),
	27963: () => (loadSingletonVersion("default", "react", false, [4,17,0,1], () => (__webpack_require__.e("node_modules_react_index_js").then(() => (() => (__webpack_require__(96540))))))),
	49703: () => (loadSingleton("default", "mdbreact", false, () => (Promise.all([__webpack_require__.e("vendors-node_modules_babel_runtime_helpers_esm_assertThisInitialized_js-node_modules_babel_ru-971898"), __webpack_require__.e("vendors-node_modules_mdbreact_dist_mdbreact_esm_js"), __webpack_require__.e("webpack_sharing_consume_default_react-dom_react-dom-webpack_sharing_consume_default_react_rea-433338"), __webpack_require__.e("webpack_sharing_consume_default_react_react-_ab69"), __webpack_require__.e("webpack_sharing_consume_default_react-dom_react-dom-webpack_sharing_consume_default_react_rea-1a77d7"), __webpack_require__.e("webpack_sharing_consume_default_moment_moment-webpack_sharing_consume_default_moment_moment-w-1b0e43")]).then(() => (() => (__webpack_require__(37851))))))),
	15355: () => (loadSingletonVersion("default", "chart.js", false, [0,3,7,0], () => (__webpack_require__.e("vendors-node_modules_chart_js_dist_chart_js").then(() => (() => (__webpack_require__(46285))))))),
	30169: () => (loadSingletonVersion("default", "react", false, [1,16,9,0], () => (__webpack_require__.e("node_modules_react_index_js").then(() => (() => (__webpack_require__(96540))))))),
	36591: () => (loadSingletonVersion("default", "react-router-dom", false, [0,5], () => (Promise.all([__webpack_require__.e("vendors-node_modules_react-router-dom_dist_index_mjs"), __webpack_require__.e("webpack_sharing_consume_default_react-dom_react-dom-webpack_sharing_consume_default_react_rea-afa71f")]).then(() => (() => (__webpack_require__(3234))))))),
	38874: () => (loadSingletonVersion("default", "styled-components", false, [1,5,3,5], () => (Promise.all([__webpack_require__.e("vendors-node_modules_styled-components_dist_styled-components_browser_esm_js"), __webpack_require__.e("webpack_sharing_consume_default_react_react-_28ef")]).then(() => (() => (__webpack_require__(27149))))))),
	49090: () => (loadSingletonVersion("default", "chart.js", false, [0,3,0,0], () => (__webpack_require__.e("vendors-node_modules_chart_js_dist_chart_js").then(() => (() => (__webpack_require__(46285))))))),
	74560: () => (loadSingletonVersion("default", "react", false, [1,15,5,4], () => (__webpack_require__.e("node_modules_react_index_js").then(() => (() => (__webpack_require__(96540))))))),
	796: () => (loadSingletonVersion("default", "react", false, [0,15,0,0], () => (__webpack_require__.e("node_modules_react_index_js").then(() => (() => (__webpack_require__(96540))))))),
	13633: () => (loadSingletonVersion("default", "react-dom", false, [1,16,3,0], () => (Promise.all([__webpack_require__.e("vendors-node_modules_react-dom_index_js"), __webpack_require__.e("webpack_sharing_consume_default_react_react-_c673")]).then(() => (() => (__webpack_require__(40961))))))),
	41119: () => (loadSingletonVersion("default", "react", false, [1,16,3,0], () => (__webpack_require__.e("node_modules_react_index_js").then(() => (() => (__webpack_require__(96540))))))),
	2283: () => (loadSingletonVersion("default", "moment", false, [1,2,22,2], () => (Promise.all([__webpack_require__.e("vendors-node_modules_moment_locale_af_js-node_modules_moment_locale_ar-dz_js-node_modules_mom-582c96"), __webpack_require__.e("node_modules_moment_locale_sync_recursive_")]).then(() => (() => (__webpack_require__(95093))))))),
	6685: () => (loadSingletonVersion("default", "react", false, [,[1,16,0,0],[1,15,0,0],[2,0,14,0],1,1], () => (__webpack_require__.e("node_modules_react_index_js").then(() => (() => (__webpack_require__(96540))))))),
	13070: () => (loadSingletonVersion("default", "moment", false, [4,2,24,0], () => (Promise.all([__webpack_require__.e("vendors-node_modules_moment_locale_af_js-node_modules_moment_locale_ar-dz_js-node_modules_mom-582c96"), __webpack_require__.e("node_modules_moment_locale_sync_recursive_")]).then(() => (() => (__webpack_require__(95093))))))),
	16344: () => (loadSingletonVersion("default", "react-dom", false, [0,15,0,0], () => (Promise.all([__webpack_require__.e("vendors-node_modules_react-dom_index_js"), __webpack_require__.e("webpack_sharing_consume_default_react_react-_c673")]).then(() => (() => (__webpack_require__(40961))))))),
	41167: () => (loadSingletonVersion("default", "react", false, [,[1,16,0,0],[1,15,0,0],[2,0,14],1,1], () => (__webpack_require__.e("node_modules_react_index_js").then(() => (() => (__webpack_require__(96540))))))),
	49811: () => (loadSingletonVersion("default", "react", false, [0,0,14,0], () => (__webpack_require__.e("node_modules_react_index_js").then(() => (() => (__webpack_require__(96540))))))),
	55983: () => (loadSingletonVersion("default", "react-dom", false, [,[1,16,0,0],[1,15,5,4],1], () => (Promise.all([__webpack_require__.e("vendors-node_modules_react-dom_index_js"), __webpack_require__.e("webpack_sharing_consume_default_react_react-_c673")]).then(() => (() => (__webpack_require__(40961))))))),
	68848: () => (loadSingletonVersion("default", "react", false, [,[1,18,0,0],[1,17,0,0],[1,16,0,0],[1,15,0,0],[2,0,14,0],1,1,1,1], () => (__webpack_require__.e("node_modules_react_index_js").then(() => (() => (__webpack_require__(96540))))))),
	75965: () => (loadSingletonVersion("default", "react-router-dom", false, [1,5,1,2], () => (Promise.all([__webpack_require__.e("vendors-node_modules_react-router_esm_react-router_js"), __webpack_require__.e("webpack_sharing_consume_default_react_react-_15a2"), __webpack_require__.e("node_modules_mdbreact_node_modules_react-router-dom_esm_react-router-dom_js")]).then(() => (() => (__webpack_require__(55745))))))),
	83269: () => (loadSingletonVersion("default", "react-dom", false, [,[1,16,0,0],[1,15,0,0],[2,0,14],1,1], () => (Promise.all([__webpack_require__.e("vendors-node_modules_react-dom_index_js"), __webpack_require__.e("webpack_sharing_consume_default_react_react-_c673")]).then(() => (() => (__webpack_require__(40961))))))),
	85617: () => (loadSingletonVersion("default", "react", false, [,[1,16,0,0],[1,15,6,1],[0,0,14,0],1,1], () => (__webpack_require__.e("node_modules_react_index_js").then(() => (() => (__webpack_require__(96540))))))),
	87525: () => (loadSingletonVersion("default", "react", false, [,[1,17,0,0],[1,16,0,0],[1,15,0,0],[2,0,14],1,1,1], () => (__webpack_require__.e("node_modules_react_index_js").then(() => (() => (__webpack_require__(96540))))))),
	89271: () => (loadSingletonVersion("default", "react", false, [,[1,16,0,0],[1,15,5,4],1], () => (__webpack_require__.e("node_modules_react_index_js").then(() => (() => (__webpack_require__(96540))))))),
	82583: () => (loadSingletonVersion("default", "react", false, [,[1,19,0,0,,"rc",1],[1,18,0,0],[1,17,0,0,,"rc",1],[1,16,8,0],1,1,1], () => (__webpack_require__.e("node_modules_react_index_js").then(() => (() => (__webpack_require__(96540))))))),
	53655: () => (loadSingletonVersion("default", "react", false, [,[1,19,0,0],[1,18,0,0],[1,17,0,0],[1,16,8,0],1,1,1], () => (__webpack_require__.e("node_modules_react_index_js").then(() => (() => (__webpack_require__(96540))))))),
	56084: () => (loadSingletonVersion("default", "react", false, [,[1,19],[1,18,0],1], () => (__webpack_require__.e("node_modules_react_index_js").then(() => (() => (__webpack_require__(96540))))))),
	6063: () => (loadSingletonVersion("default", "react", false, [0,18], () => (__webpack_require__.e("node_modules_react_index_js").then(() => (() => (__webpack_require__(96540))))))),
	58900: () => (loadSingletonVersion("default", "react-dom", false, [0,18], () => (Promise.all([__webpack_require__.e("vendors-node_modules_react-dom_index_js"), __webpack_require__.e("webpack_sharing_consume_default_react_react-_c673")]).then(() => (() => (__webpack_require__(40961))))))),
	38761: () => (loadSingletonVersion("default", "moment", false, [1,2,30,1], () => (Promise.all([__webpack_require__.e("vendors-node_modules_moment_locale_af_js-node_modules_moment_locale_ar-dz_js-node_modules_mom-582c96"), __webpack_require__.e("node_modules_moment_locale_sync_recursive_")]).then(() => (() => (__webpack_require__(95093))))))),
	5370: () => (loadSingletonVersion("default", "react", false, [,[1,17,0,0],[1,16,8,0],1], () => (__webpack_require__.e("node_modules_react_index_js").then(() => (() => (__webpack_require__(96540))))))),
	14158: () => (loadSingletonVersion("default", "redux", false, [1,4,0,4], () => (__webpack_require__.e("node_modules_dnd-core_node_modules_redux_es_redux_js-_c7d11").then(() => (() => (__webpack_require__(62544))))))),
	28437: () => (loadSingletonVersion("default", "react", false, [0], () => (__webpack_require__.e("node_modules_react_index_js").then(() => (() => (__webpack_require__(96540))))))),
	51068: () => (loadSingletonVersion("default", "react", false, [,[1,19,0,0],[1,18,0,0],[1,17,0,0],[1,16,3,0],1,1,1], () => (__webpack_require__.e("node_modules_react_index_js").then(() => (() => (__webpack_require__(96540))))))),
	55853: () => (loadSingletonVersion("default", "react", false, [,[1,16,0,0],[1,15,3,0],1], () => (__webpack_require__.e("node_modules_react_index_js").then(() => (() => (__webpack_require__(96540))))))),
	67666: () => (loadSingletonVersion("default", "react", false, [0,16,9,0], () => (__webpack_require__.e("node_modules_react_index_js").then(() => (() => (__webpack_require__(96540))))))),
	5291: () => (loadSingletonVersion("default", "react", false, [0,16,8], () => (__webpack_require__.e("node_modules_react_index_js").then(() => (() => (__webpack_require__(96540))))))),
	16072: () => (loadSingletonVersion("default", "react", false, [1,18], () => (__webpack_require__.e("node_modules_react_index_js").then(() => (() => (__webpack_require__(96540))))))),
	39449: () => (loadSingletonVersion("default", "react", false, [0,18,0], () => (__webpack_require__.e("node_modules_react_index_js").then(() => (() => (__webpack_require__(96540))))))),
	50611: () => (loadSingletonVersion("default", "react", false, [0,16,13], () => (__webpack_require__.e("node_modules_react_index_js").then(() => (() => (__webpack_require__(96540))))))),
	75465: () => (loadSingletonVersion("default", "react", false, [,[-1,19],[0,18],2], () => (__webpack_require__.e("node_modules_react_index_js").then(() => (() => (__webpack_require__(96540))))))),
	97656: () => (loadSingletonVersion("default", "react", false, [1,18,0,0], () => (__webpack_require__.e("node_modules_react_index_js").then(() => (() => (__webpack_require__(96540)))))))
};
// no consumes in initial chunks
const chunkMapping = {
	"webpack_sharing_consume_default_react_react-_c673": [
		50318
	],
	"webpack_sharing_consume_default_axios_axios": [
		9734
	],
	"webpack_sharing_consume_default_customer_portal-ui-shared_customer_portal-ui-shared": [
		59166
	],
	"webpack_sharing_consume_default_react-dom_react-dom-webpack_sharing_consume_default_react_rea-433338": [
		41727,
		47359
	],
	"webpack_sharing_consume_default_react_react-_4a07": [
		55931
	],
	"webpack_sharing_consume_default_react_react-_28ef": [
		31245
	],
	"webpack_sharing_consume_default_react_react-_4ccd": [
		51532
	],
	"webpack_sharing_consume_default_react_react-_e215": [
		41935
	],
	"webpack_sharing_consume_default_react-dom_react-dom": [
		70058
	],
	"webpack_sharing_consume_default_react-redux_react-redux": [
		93917
	],
	"webpack_sharing_consume_default_src_context_VesselContext_context_VesselContext": [
		17040
	],
	"webpack_sharing_consume_default_react-router-dom_react-router-dom": [
		31821
	],
	"src_Paths_js-webpack_sharing_consume_default_react_react": [
		93015
	],
	"src_store_storeConfig_js": [
		41347
	],
	"webpack_sharing_consume_default_src_context_VesselSubscriptionContext_context_VesselSubscript-a382fa": [
		94442
	],
	"src_Common_Constants_js-src_Services_Common_AccessControl_js-src_bootstrap_js-webpack_sharing-91bac7": [
		33073
	],
	"webpack_sharing_consume_default_react_react-_15a2": [
		30668
	],
	"webpack_sharing_consume_default_mdbreact_mdbreact-webpack_sharing_consume_default_react-dom_r-327f02": [
		23285,
		27963,
		49703
	],
	"webpack_sharing_consume_default_chart_js_chart_js-webpack_sharing_consume_default_chart_js_ch-8d835d": [
		15355,
		30169,
		36591,
		38874,
		49090,
		74560
	],
	"webpack_sharing_consume_default_react_react-_ab69": [
		796
	],
	"webpack_sharing_consume_default_react-dom_react-dom-webpack_sharing_consume_default_react_rea-1a77d7": [
		13633,
		41119
	],
	"webpack_sharing_consume_default_moment_moment-webpack_sharing_consume_default_moment_moment-w-1b0e43": [
		2283,
		6685,
		13070,
		16344,
		41167,
		49811,
		55983,
		68848,
		75965,
		83269,
		85617,
		87525,
		89271
	],
	"webpack_sharing_consume_default_react_react-_5a49": [
		82583
	],
	"webpack_sharing_consume_default_react_react-webpack_sharing_consume_default_react_react": [
		53655,
		56084
	],
	"webpack_sharing_consume_default_react-dom_react-dom-webpack_sharing_consume_default_react_rea-afa71f": [
		6063,
		58900
	],
	"webpack_sharing_consume_default_moment_moment": [
		38761
	],
	"webpack_sharing_consume_default_react_react-webpack_sharing_consume_default_react_react-webpa-84f690": [
		5370,
		14158,
		28437,
		51068,
		55853,
		67666
	],
	"webpack_sharing_consume_default_react_react-_6492": [
		5291
	],
	"src_components_Structural_Structural_tsx-webpack_sharing_consume_default_react_react-webpack_-061a82": [
		16072,
		39449,
		50611,
		75465,
		97656
	]
};
const startedInstallModules = {};
__webpack_require__.f.consumes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			if(__webpack_require__.o(installedModules, id)) return promises.push(installedModules[id]);
			if(!startedInstallModules[id]) {
			const onFactory = (factory) => {
				installedModules[id] = 0;
				__webpack_require__.m[id] = (module) => {
					delete __webpack_require__.c[id];
					module.exports = factory();
				}
			};
			startedInstallModules[id] = true;
			const onError = (error) => {
				delete installedModules[id];
				__webpack_require__.m[id] = (module) => {
					delete __webpack_require__.c[id];
					throw error;
				}
			};
			try {
				const promise = moduleToHandlerMapping[id]();
				if(promise.then) {
					promises.push(installedModules[id] = promise.then(onFactory)['catch'](onError));
				} else onFactory(promise);
			} catch(e) { onError(e); }
			}
		});
	}
}